// Infinite scroll for product grids (collection + search) and the collections index. Progressive
// enhancement: the "Load more" link works as a normal link without JS.
(function () {
  var root = document.querySelector('[data-lv-infinite]');
  var grid = document.querySelector('[data-lv-infinite-grid], .lv-collection-grid');
  if (!root || !grid) return;

  var nextUrl = root.getAttribute('data-next-url');
  var moreLink = root.querySelector('[data-lv-infinite-more]');
  var status = root.querySelector('[data-lv-infinite-status]');
  var loading = false;
  var observer = null;

  function finish() {
    nextUrl = '';
    if (observer) observer.disconnect();
    if (moreLink) moreLink.remove();
    status.textContent = '';
  }

  function load() {
    if (loading || !nextUrl) return;
    loading = true;
    root.classList.add('is-loading');
    status.textContent = 'Loading more…';

    fetch(nextUrl, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('Request failed: ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nextGrid = doc.querySelector('[data-lv-infinite-grid], .lv-collection-grid');
        var nextRoot = doc.querySelector('[data-lv-infinite]');

        if (nextGrid) {
          Array.prototype.slice.call(nextGrid.children).forEach(function (node) {
            if (node.classList.contains('lv-collection-empty')) return;
            grid.appendChild(document.importNode(node, true));
          });
        }

        nextUrl = nextRoot ? nextRoot.getAttribute('data-next-url') : '';
        if (moreLink && nextUrl) moreLink.setAttribute('href', nextUrl);

        status.textContent = '';
        if (!nextUrl) {
          finish();
        } else if (observer) {
          // Re-arm so a short page still triggers another load.
          observer.unobserve(root);
          observer.observe(root);
        }
      })
      .catch(function () {
        status.textContent = 'Couldn’t load more. Please try again.';
      })
      .then(function () {
        loading = false;
        root.classList.remove('is-loading');
      });
  }

  if (moreLink) {
    moreLink.addEventListener('click', function (event) {
      event.preventDefault();
      load();
    });
  }

  if ('IntersectionObserver' in window && nextUrl) {
    observer = new IntersectionObserver(
      function (entries) {
        if (entries[0].isIntersecting) load();
      },
      { rootMargin: '900px 0px' }
    );
    observer.observe(root);
  }
})();
